import React from "react";
import { toast } from "react-toastify";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import { Box, Button } from "@mui/material";

import { useDealActions, useDealIdSelector, useDealSelector, useOpportunityIdSelector } from "store";
import { opportunityStatuses } from "constants/deal";
import { StatusComponentGuard } from "components";

export const LetsTalkButton = () => {
  const { opportunity_id } = useDealSelector();
  const { updateOpportunitiesStatusAction, getDealAndStoreAction } = useDealActions();
  const dealId = useDealIdSelector();
  const opportunityId = useOpportunityIdSelector();

  const onOpportunityStatusChange = async (status: string) => {
    if (!opportunity_id || !dealId) return;
    await updateOpportunitiesStatusAction({ id: opportunity_id, status: status });
    await getDealAndStoreAction(dealId);
    toast("Great! We will contact you shortly");
  };
  return (
    <StatusComponentGuard statuses={[opportunityId]} show={true}>
      <Box
        sx={{
          bottom: "31px",
          left: "calc(50% - 75px)",
          position: "absolute",
          borderRadius: "48px",
          width: "150px",
          height: "56px",
          boxShadow: "0 4px 10px 0 rgba(0, 0, 0, 0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fff",
          zIndex: 1
        }}
      >
        <Button
          onClick={() => onOpportunityStatusChange(opportunityStatuses.APPLY)}
          variant="contained"
          startIcon={<HandshakeOutlinedIcon sx={{ color: "#fff" }} />}
        >
          {" "}
          Lets talk
        </Button>
      </Box>
    </StatusComponentGuard>
  );
};
